<div class="d-inline-flex gap-2 align-items-center">
  <i class="flag-icon" [class]="codeClassName()"></i>
  @if (languageName(); as name) {
    <span>{{ name }}</span>
  }
</div>
